 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACKCOVERTEXT from '@/components/BackCoverText'
 import PRAISE from '@/components/Praise'
 import BOOKLIST from '@/components/Booklist'
 import TITLEPAGE from '@/components/TitlePage'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import PROLOGUE from '@/components/Prologue'
 import CHAPTERONE from '@/components/ChapterOne'
 import CHAPTERTWO from '@/components/ChapterTwo'
 import CHAPTERTHREE from '@/components/ChapterThree'
 import CHAPTERFOUR from '@/components/ChapterFour'
 import CHAPTERFIVE from '@/components/ChapterFive'
 import CHAPTERSIX from '@/components/ChapterSix'
 import CHAPTERSEVEN from '@/components/ChapterSeven'
 import CHAPTEREIGHT from '@/components/ChapterEight'
 import CHAPTERNINE from '@/components/ChapterNine'
 import CHAPTERTEN from '@/components/ChapterTen'
 import CHAPTERELEVEN from '@/components/ChapterEleven'
 import CHAPTERTWELVE from '@/components/ChapterTwelve'
 import CHAPTERTHIRTEEN from '@/components/ChapterThirteen'
 import CHAPTERFOURTEEN from '@/components/ChapterFourteen'
 import CHAPTERFIFTEEN from '@/components/ChapterFifteen'
 import CHAPTERSIXTEEN from '@/components/ChapterSixteen'
 import CHAPTERSEVENTEEN from '@/components/ChapterSeventeen'
 import CHAPTEREIGHTEEN from '@/components/ChapterEighteen'
 import CHAPTERNINETEEN from '@/components/ChapterNineteen'
 import CHAPTERTWENTY from '@/components/ChapterTwenty'
 import CHAPTERTWENTYONE from '@/components/ChapterTwentyOne'
 import CHAPTERTWENTYTWO from '@/components/ChapterTwentyTwo'
 import CHAPTERTWENTYTHREE from '@/components/ChapterTwentyThree'
 import CHAPTERTWENTYFOUR from '@/components/ChapterTwentyFour'
 import CHAPTERTWENTYFIVE from '@/components/ChapterTwentyFive'
 import CHAPTERTWENTYSIX from '@/components/ChapterTwentySix'
 import CHAPTERTWENTYSEVEN from '@/components/ChapterTwentySeven'
 import CHAPTERTWENTYEIGHT from '@/components/ChapterTwentyEight'
 import CHAPTERTWENTYNINE from '@/components/ChapterTwentyNine'
 import CHAPTERTHIRTY from '@/components/ChapterThirty'
 import CHAPTERTHIRTYONE from '@/components/ChapterThirtyOne'
 import CHAPTERTHIRTYTWO from '@/components/ChapterThirtyTwo'
 import CHAPTERTHIRTYTHREE from '@/components/ChapterThirtyThree'
 import CHAPTERTHIRTYFOUR from '@/components/ChapterThirtyFour'
 import CHAPTERTHIRTYFIVE from '@/components/ChapterThirtyFive'
 import CHAPTERTHIRTYSIX from '@/components/ChapterThirtySix'
 import CHAPTERTHIRTYSEVEN from '@/components/ChapterThirtySeven'
 import CHAPTERTHIRTYEIGHT from '@/components/ChapterThirtyEight'
 import CHAPTERTHIRTYNINE from '@/components/ChapterThirtyNine'
 import CHAPTERFORTY from '@/components/ChapterForty'
 import CHAPTERFORTYONE from '@/components/ChapterFortyOne'
 import CHAPTERFORTYTWO from '@/components/ChapterFortyTwo'
 import CHAPTERFORTYTHREE from '@/components/ChapterFortyThree'
 import CHAPTERFORTYFOUR from '@/components/ChapterFortyFour'
 import CHAPTERFORTYFIVE from '@/components/ChapterFortyFive'
 import CHAPTERFORTYSIX from '@/components/ChapterFortySix'
 import CHAPTERFORTYSEVEN from '@/components/ChapterFortySeven'
 import CHAPTERFORTYEIGHT from '@/components/ChapterFortyEight'
 import CHAPTERFORTYNINE from '@/components/ChapterFortyNine'
 import CHAPTERFIFTY from '@/components/ChapterFifty'
 import CHAPTERFIFTYONE from '@/components/ChapterFiftyOne'
 import CHAPTERFIFTYTWO from '@/components/ChapterFiftyTwo'
 import CHAPTERFIFTYTHREE from '@/components/ChapterFiftyThree'
 import CHAPTERFIFTYFOUR from '@/components/ChapterFiftyFour'
 import CHAPTERFIFTYFIVE from '@/components/ChapterFiftyFive'
 import CHAPTERFIFTYSIX from '@/components/ChapterFiftySix'
 import CHAPTERFIFTYSEVEN from '@/components/ChapterFiftySeven'
 import CHAPTERFIFTYEIGHT from '@/components/ChapterFiftyEight'
 import CHAPTERFIFTYNINE from '@/components/ChapterFiftyNine'
 import CHAPTERSIXTY from '@/components/ChapterSixty'
 import CHAPTERSIXTYONE from '@/components/ChapterSixtyOne'
 import CHAPTERSIXTYTWO from '@/components/ChapterSixtyTwo'
 import CHAPTERSIXTYTHREE from '@/components/ChapterSixtyThree'
 import CHAPTERSIXTYFOUR from '@/components/ChapterSixtyFour'
 import CHAPTERSIXTYFIVE from '@/components/ChapterSixtyFive'
 import CHAPTERSIXTYSIX from '@/components/ChapterSixtySix'
 import CHAPTERSIXTYSEVEN from '@/components/ChapterSixtySeven'
 import CHAPTERSIXTYEIGHT from '@/components/ChapterSixtyEight'
 import CHAPTERSIXTYNINE from '@/components/ChapterSixtyNine'
 import CHAPTERSEVENTY from '@/components/ChapterSeventy'
 import CHAPTERSEVENTYONE from '@/components/ChapterSeventyOne'
 import CHAPTERSEVENTYTWO from '@/components/ChapterSeventyTwo'
 import CHAPTERSEVENTYTHREE from '@/components/ChapterSeventyThree'
 import EPILOGUE from '@/components/Epilogue'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Prologue",
 			"name" : "Prologue",
 			"component" : PROLOGUE
 		},
 		{
 			"path" : "/ChapterOne",
 			"name" : "ChapterOne",
 			"component" : CHAPTERONE
 		},
 		{
 			"path" : "/ChapterTwo",
 			"name" : "ChapterTwo",
 			"component" : CHAPTERTWO
 		},
 		{
 			"path" : "/ChapterThree",
 			"name" : "ChapterThree",
 			"component" : CHAPTERTHREE
 		},
 		{
 			"path" : "/ChapterFour",
 			"name" : "ChapterFour",
 			"component" : CHAPTERFOUR
 		},
 		{
 			"path" : "/ChapterFive",
 			"name" : "ChapterFive",
 			"component" : CHAPTERFIVE
 		},
 		{
 			"path" : "/ChapterSix",
 			"name" : "ChapterSix",
 			"component" : CHAPTERSIX
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js